import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Topics from './components/Topics';
import IndexSection from './components/IndexSection';
import Carousel from './components/Carousel';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import Comments from './components/Comments';
import Ranking from './components/Ranking';
import About from './components/About';
import CardsSection from './components/CardsSection';
import Updates from './components/Updates';
import FAQ from './components/FAQ';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Features />
        <Topics />
        <IndexSection />
        <Carousel />
        <ContactSection />
        <AppSection />
        <Comments />
        <Ranking />
        <About />
        <CardsSection />
        <Updates />
        <FAQ />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}